import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';
import {PricingCustomField} from '../pricing-custom-field';


@JsonObject('model.TempPricingMiscItem')
export class TempPricingMiscItem extends AbstractModel {
  @JsonProperty(Number, 'id')
  id?: number

  @JsonProperty(String, 'name')
  name?: string

  @JsonProperty(Number, 'pricePerItem')
  pricePerItem?: number
}

@JsonObject('model.PricingGroupItemSocketGroup')
export class PricingGroupItemSocketGroup extends AbstractModel {
  @JsonProperty(Number, 'id')
  id?: number

  @JsonProperty(String, 'name')
  name?: string
}

@JsonObject('model.PricingGroupItem')
export class PricingGroupItem extends AbstractModel {
  @JsonProperty(Number, 'id')
  id?: number

  @JsonProperty(Number, 'pos')
  pos?: number

  @JsonProperty(String, 'name')
  name?: string

  @JsonProperty(Number, 'value')
  value?: number

  @JsonProperty(Number, 'height')
  height?: number

  @JsonProperty(Number, 'width')
  width?: number

  @JsonProperty(Number, 'depth')
  depth?: number

  @JsonProperty(Number, 'qty')
  qty?: number

  @JsonProperty(Number, 'price')
  price?: number

  @JsonProperty(String, 'note')
  note?: string

  @JsonProperty(Number, 'historyPrice')
  historyPrice?: number

  @JsonProperty([PricingCustomField], 'customFields')
  customFields?: PricingCustomField[] = [];

  @JsonProperty(TempPricingMiscItem, 'misc')
  misc?: TempPricingMiscItem = new TempPricingMiscItem();

  @JsonProperty(PricingGroupItemSocketGroup, 'group')
  group?: PricingGroupItemSocketGroup

  @JsonProperty(String, 'lastInteractionTime')
  lastInteractionTime?: string;
}

